/* eslint-disable prefer-template */
/* eslint-disable no-useless-concat */
import Cookies from 'js-cookie';

export const getAuthToken = (): string | null => Cookies.get('sessionEnt') ?? null;
export const getRefreshToken = (): string | null => Cookies.get('refreshTokenEnt') ?? null;
const domain = window.location.hostname;
const subDomain = '.' + window.location.hostname.split('.').reverse()[1] + '.' + window.location.hostname.split('.').reverse()[0];

// Although auth tokens expire within 20 minutes, the cookie expiry is set to 7 days.
// This ensures the cookie isn’t deleted if the user is inactive for up to a week.
// Since the refresh token is still available, the application can request a new
// auth token even if the existing one has expired.
export const setAuthToken = (token: string) => {
  Cookies.set('sessionEnt', token, {
    path: '/',
    domain,
    expires: 7, // 1 week
  });
  Cookies.set('sessionEnt-ws-admin', token, {
    path: '/',
    domain: subDomain,
    expires: 7, // 1 week
  });
};
export const setRefreshToken = (refreshToken: string) => {
  Cookies.set('refreshTokenEnt', refreshToken, {
    path: '/',
    domain,
    expires: 7, // 1 week
  });
  Cookies.set('refreshTokenEnt-ws-admin', refreshToken, {
    path: '/',
    domain: subDomain,
    expires: 7, // 1 week
  });
};

export const clearAuthToken = () => {
  Cookies.remove('sessionEnt', {
    path: '/',
    domain,
  });
  Cookies.remove('refreshTokenEnt', {
    path: '/',
    domain,
  });
  Cookies.remove('sessionEnt-ws-admin', {
    path: '/',
    domain: subDomain,
  });
  Cookies.remove('refreshTokenEnt-ws-admin', {
    path: '/',
    domain: subDomain,
  });
};
